import Vue from "vue";
import VueI18n from "vue-i18n";
import { createI18n } from "vue-i18n-composable";

import messages from "./locales";

Vue.use(VueI18n);

const i18n = createI18n({
  locale: "fr",
  fallbackLocale: "fr",
  formatFallbackMessages: true,
  messages,
  numberFormats: {
    fr: {
      currency_cad: {
        style: "currency",
        currency: "CAD",
        currencyDisplay: "narrowSymbol",
      },
      // Dollars only, no cents
      dollars_cad: {
        style: "currency",
        currency: "CAD",
        currencyDisplay: "narrowSymbol",
        maximumFractionDigits: 0,
      },
      percent: {
        style: "percent",
        minimumFractionDigits: 2, // x.xx
      },
    },
  },
});

export default i18n;
